import { render, staticRenderFns } from "./heartLung.vue?vue&type=template&id=628ff96a&scoped=true&"
import script from "./heartLung.vue?vue&type=script&lang=js&"
export * from "./heartLung.vue?vue&type=script&lang=js&"
import style0 from "./heartLung.vue?vue&type=style&index=0&id=628ff96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ff96a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('628ff96a')) {
      api.createRecord('628ff96a', component.options)
    } else {
      api.reload('628ff96a', component.options)
    }
    module.hot.accept("./heartLung.vue?vue&type=template&id=628ff96a&scoped=true&", function () {
      api.rerender('628ff96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/heartLung.vue"
export default component.exports